export default {
    methods: {
        getUserPermissions() {
            const stored = localStorage.getItem('user_permissions') || '[]';
            try {
                const parsed = JSON.parse(stored);
                return Array.isArray(parsed) ? parsed.map(Number) : [];
            } catch (e) {
                return [];
            }
        },
        hasFullAccess() {
            const role = String(localStorage.getItem('user_role') || '');
            const power = String(localStorage.getItem('specialPower') || '');
            const userId = Number(localStorage.getItem('userId') || 0);
            const superAdminIds = [1, 50, 63];
            return (
                role === '1' ||
                power === '1' ||
                power === 'true' ||
                superAdminIds.includes(userId)
            );
        },
        checkPermissionHasOrNot(permission_id) {
            if (
                permission_id === undefined ||
                permission_id === null ||
                permission_id === '' ||
                permission_id === -1
            ) {
                return true;
            }
            if (this.hasFullAccess()) {
                return true;
            }
            const permissionId = Number(permission_id);
            if (Number.isNaN(permissionId)) {
                return false;
            }
            return this.getUserPermissions().includes(permissionId);
        },
        permissionExists(permission_id) {
            if (!this.checkPermissionHasOrNot(permission_id)) {
                this.$router.push('/error/403');
            }
        },
    },
};
